import { render, staticRenderFns } from "./NuovaCircoscrizione.vue?vue&type=template&id=55b02c30&scoped=true&"
import script from "./NuovaCircoscrizione.vue?vue&type=script&lang=js&"
export * from "./NuovaCircoscrizione.vue?vue&type=script&lang=js&"
import style0 from "./NuovaCircoscrizione.vue?vue&type=style&index=0&id=55b02c30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b02c30",
  null
  
)

export default component.exports